import React from "react";
import Progress from "@mui/material/LinearProgress";
import PropTypes from "prop-types";

const commonStyles = {
  root: (theme: any) => ({
    margin: `${theme.spacing(1)}px 0`,
    width: `${theme.spacing(20)}px`,
  }),
  name: "RaLinearProgress",
};

/**
 * Progress bar formatted to replace an input or a field in a form layout
 *
 * Avoids visual jumps when replaced by value or form input
 *
 * @see ReferenceField
 * @see ReferenceInput
 *
 * @param {Object} classes CSS class names
 */
const LinearProgress = (props: any) => {
  return <Progress sx={commonStyles.root} {...props} />;
};
LinearProgress.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
};
// wat? TypeScript looses the displayName if we don't set it explicitly
LinearProgress.displayName = "LinearProgress";

export default LinearProgress;
